import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SpLevel, SpLevelsor } from '../../../../core/entity/printportal';
import { Subject } from 'rxjs';
import { CoreService } from '../../../../core/service/core.service';
import { PrintportalService } from '../../../../core/service/printportal.service';
import { CoreResponse } from '@scrollmax/core-nextgen';
import { ScrollLevelService } from '../../../../core/service/scrolllevel.service';
import { IOfferDatarows, IOfferPrices, IOfferVersion } from '../../../../core/interfaces/printportal.interfaces';

@Component({
  selector: 'app-offer-compare',
  templateUrl: './offer-compare.component.html',
  styleUrl: './offer-compare.component.scss'
})
export class OfferCompareComponent implements OnInit {

  // a levél kódunk kerül bele
  private levelKod: number;
  
  // a sablonhoz összeállított adatok kerülnek bele
  public levelSablon: {
    levelcim?: string,
    ajanlatcim?: string,
    kuldonev?: string,
    megszolitas?: string,
    ajanlatszoveg?: string[], // p tagokba kellene renderelni
    utoszoveg?: string,
    verziok?: IOfferVersion[]
  } = {};

  // levelél entitás
  public level: SpLevel;
  // levélsor entitás
  public levelSor: SpLevelsor[] = [];
  
  // csak a vizuálhoz használjuk
  // TODO amíg nem tudjuk megfejteni, miért nem működik a KTAccordion
  public verzioAccordions: { index: number, state?: number }[] = [{ index: 0, state: 0}];

  destroy$: Subject<void> = new Subject();

  loading$: Subject<boolean> = new Subject();

  // a signalból lehúzzuk a state-t
  public scrollParam = this.coreService.scrollParamsState();

  constructor(
    private route: ActivatedRoute, 
    private coreService: CoreService, 
    private printportalService: PrintportalService,
    private scrollLevelService: ScrollLevelService,
    private cdr: ChangeDetectorRef
  ) {
    this.loading$.next(true);
  }

  ngOnInit(): void {
    
    this.route.params.subscribe(p => {
      this.levelKod = parseInt(p['id']);
      this.fetchComponentData();
    });

  }

  onChangeAccordionState(index: number, state: number): void {
    this.verzioAccordions.find(va => va.index === index).state = state;
  }

  fetchComponentData(): void {

    this.printportalService.getLevel(this.levelKod).subscribe({ next: (r: CoreResponse) => {

          this.level = r.getDataByIndex<SpLevel>(0);
          // néhány adatot kiveszünk lokális változóba
          this.levelSablon.levelcim = this.level.elso_verzio_cim;
          
          // megcsináljuk a levélverziók adatait
          this.onCreateVersions();

          // jelezzük, hogy betöltöttünk mindent
          this.loading$.next(false);

    }});

  }

  /**
   * Ajánlati verziók elkészítése
   */
  onCreateVersions(): void {

    this.scrollLevelService.init(this.level, this.levelSor);
    
    this.levelSablon.ajanlatcim = this.scrollLevelService.getAjanlatCim();
    this.levelSablon.kuldonev = this.level?.getKuldoNev();

    this.levelSablon.megszolitas = this.scrollLevelService.getMegszolitas();
    this.levelSablon.ajanlatszoveg = this.scrollLevelService.getAjanlatSzoveg();
    this.levelSablon.utoszoveg = this.scrollLevelService.getAjanlatUtoSzoveg();

    this.levelSablon.verziok = [];

    let verzioIndex = 1;
    // Minden esetben a levélből indulunk!
    (this.level.getRendelesAdatok() as Array<unknown>).forEach(adatok => {

      const v: IOfferVersion = {} as unknown as IOfferVersion;
      v.index = verzioIndex;
      v.level = this.level.kod;
      v.version = adatok['verzio'];
      v.adatsorok = (adatok['rendeleshez'] as Array<IOfferDatarows>).sort((n1, n2) => n1.kod - n2.kod);
      v.arak = (this.level.arak as Array<IOfferPrices>).filter(a => a.rendeles === adatok['verzio']);
      v.title = adatok['cim'];
      v.description = this.scrollLevelService.formatVerzioSzoveg(adatok['szoveg']);
      v.kelt = this.level.kelt;
      v.rendelheto = true;

      // napokban lehet beállítani a rendelhetőséget, paramsból kapjuk vissza
      const now = new Date();
      const max = new Date(v.kelt);
      const days = parseInt(this.scrollParam.get('option_rendeles_naplimit').get('90'));
      max.setDate(max.getDate() + days);

      // beállítjuk a rendelhetőséget
      if (max < now)
        v.rendelheto = false;

      // pusholjuk a verzió adatainkat a sablon objektumba
      this.levelSablon.verziok.push(v);
      // a vizuálra dolgozunk rá, az accordionjainkat fogjuk ezzel kezelni
      this.verzioAccordions.push({ index: verzioIndex, state: 1 });

      // növeljük az indexet
      verzioIndex++;

    });
    

  }

}
